import React from 'react';

const EditAdmin = () => {
    return (
        <div>
            
        </div>
    );
};

export default EditAdmin;
